import { render, staticRenderFns } from "./BecomeVendor.vue?vue&type=template&id=6c92407c"
import script from "./BecomeVendor.vue?vue&type=script&lang=js"
export * from "./BecomeVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports